import { useState } from "react"
import { useTranslation } from "react-i18next"
import TransferRow from "./TransferRow"
import ExpandableOptionsRow from "../../common/ExpandableOptionsRow"
import { IoMdClose } from "react-icons/io"
import UnitAchRescheduleRequest from "../UnitPage/UnitAchRescheduleRequest"

export default function PendingTransferRow({ transfer }) {
  const { t } = useTranslation()
  const [optionsOpen, setOptionsOpen] = useState(false)
  const isAbleToRequestAchReschedule = (
    transfer.attributes["transfer-change-request"] == null &&
    transfer.attributes["status"] == 1
  )

  const optionsRowItems = [
    ...(isAbleToRequestAchReschedule ? [{
      icon: <UnitAchRescheduleRequest
        transfer={transfer}
        isOnPendingTransfersPage={true}
        setOptionsOpen={setOptionsOpen}
      />,
      onClick: () => { }
    }] : []),
    {
      icon: <IoMdClose />,
      label: t('Close'),
      onClick: () => setOptionsOpen(false)
    }
  ]

  return (
    <ExpandableOptionsRow
      items={optionsRowItems}
      optionsOpen={optionsOpen}
    >
      <TransferRow
        date={transfer.attributes['actual-transfer-date']}
        type={transfer.attributes['payment-type']}
        unitName={`${transfer.attributes.make} ${transfer.attributes.model}`}
        amount={transfer.attributes.amount}
        filter={''}
        key={transfer.id}
        isExpandable={true}
        onExpand={() => setOptionsOpen(true)}
      />
    </ExpandableOptionsRow>
  )
}
